export function downloadContentAsFile({
  content,
  filename,
  mimeType = 'application/octet-stream',
}: {
  content: string;
  filename: string;
  mimeType?: string;
}): void {
  const blob = new Blob([content], { type: mimeType });
  const url = URL.createObjectURL(blob);
  downloadUrlAsFile({ url, filename });
  URL.revokeObjectURL(url);
}

export function downloadBase64AsFile({
  contentBase64,
  filename,
  mimeType = 'application/octet-stream',
}: {
  contentBase64: string;
  filename: string;
  mimeType?: string;
}): void {
  const normalized = contentBase64.replace(/\s+/g, '');
  const binary = atob(normalized);
  const bytes = new Uint8Array(binary.length);
  for (let index = 0; index < binary.length; index += 1) {
    bytes[index] = binary.charCodeAt(index);
  }
  const blob = new Blob([bytes], { type: mimeType });
  const url = URL.createObjectURL(blob);
  downloadUrlAsFile({ url, filename });
  URL.revokeObjectURL(url);
}

export function downloadUrlAsFile({
  url,
  filename,
}: {
  url: string;
  filename?: string;
}): void {
  const link = document.createElement('a');
  link.href = url;
  link.download = filename ?? '';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}
